import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

const FilterField = ({ label, children }) => (
  <div className="account-filter-field">
    <span>{label}</span>
    {children}
  </div>
);

const RegistrationReviewFilters = ({
  type,
  filters,
  searchDraft,
  onSearchChange,
  onChange,
  onClear,
  text
}) => {
  const [showCustomRange, setShowCustomRange] = useState(false);
  const [customRange, setCustomRange] = useState({ from: "", to: "" });

  useEffect(() => {
    setCustomRange({
      from: filters.registeredFrom || "",
      to: filters.registeredTo || ""
    });
  }, [filters.registeredFrom, filters.registeredTo]);

  const validCustomRange = Boolean(
    customRange.from && customRange.to && customRange.from <= customRange.to
  );
  const hasActiveFilters = Boolean(
    searchDraft.trim() ||
      filters.reviewStatus ||
      (filters.datePreset && filters.datePreset !== "all") ||
      filters.sort === "registeredAt:asc"
  );

  const changeDatePreset = (value) => {
    if (value === "custom") {
      setShowCustomRange(true);
      return;
    }
    onChange({
      datePreset: value,
      registeredFrom: "",
      registeredTo: ""
    });
  };

  const applyCustomRange = () => {
    if (!validCustomRange) return;
    onChange({
      datePreset: "custom",
      registeredFrom: customRange.from,
      registeredTo: customRange.to
    });
    setShowCustomRange(false);
  };

  return (
    <>
      <div className="account-toolbar registration-review-filter-bar" aria-label={text.filters}>
        <label className="account-search">
          <i className="fa-solid fa-magnifying-glass" aria-hidden="true" />
          <input
            type="search"
            value={searchDraft}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder={
              type === "customers"
                ? text.searchCustomerReviews
                : text.searchMerchantRegistrations
            }
          />
        </label>
        <FilterField label={text.reviewStatus}>
          <select
            aria-label={text.reviewStatus}
            value={filters.reviewStatus || ""}
            onChange={(event) => onChange({ reviewStatus: event.target.value })}
          >
            <option value="">{text.allReviewStatuses}</option>
            <option value="PENDING_REVIEW">{text.pending}</option>
            <option value="REUPLOAD_REQUIRED">{text.reupload}</option>
            <option value="REJECTED">{text.rejected}</option>
          </select>
        </FilterField>
        <FilterField label={text.registrationDate}>
          <div className="registration-review-date-filter-control">
            <select
              aria-label={text.registrationDate}
              value={filters.datePreset || "all"}
              onChange={(event) => changeDatePreset(event.target.value)}
            >
              <option value="all">{text.allDates}</option>
              <option value="today">{text.today}</option>
              <option value="last7">{text.last7Days}</option>
              <option value="last30">{text.last30Days}</option>
              <option value="last90">{text.last90Days}</option>
              <option value="custom">{text.customRange}</option>
            </select>
            {filters.datePreset === "custom" && (
              <button
                type="button"
                className="registration-review-custom-range"
                onClick={() => setShowCustomRange(true)}
              >
                {filters.registeredFrom} — {filters.registeredTo}
              </button>
            )}
          </div>
        </FilterField>
        <FilterField label={text.sortBy}>
          <select
            aria-label={text.sortBy}
            value={filters.sort || "registeredAt:desc"}
            onChange={(event) => onChange({ sort: event.target.value })}
          >
            <option value="registeredAt:desc">{text.newest}</option>
            <option value="registeredAt:asc">{text.oldest}</option>
          </select>
        </FilterField>
        <button
          type="button"
          className={`account-clear-filters ${hasActiveFilters ? "" : "is-placeholder"}`}
          onClick={onClear}
          disabled={!hasActiveFilters}
          tabIndex={hasActiveFilters ? 0 : -1}
          aria-hidden={!hasActiveFilters}
        >
          {text.clearFilters}
        </button>
      </div>

      <Modal
        show={showCustomRange}
        onHide={() => setShowCustomRange(false)}
        centered
        aria-labelledby="registration-date-range-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="registration-date-range-title">
            {text.customRegistrationRange}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="registration-review-date-range">
            <FilterField label={text.fromDate}>
              <input
                aria-label={text.fromDate}
                type="date"
                value={customRange.from}
                max={customRange.to || undefined}
                onChange={(event) =>
                  setCustomRange((current) => ({
                    ...current,
                    from: event.target.value
                  }))
                }
              />
            </FilterField>
            <FilterField label={text.toDate}>
              <input
                aria-label={text.toDate}
                type="date"
                value={customRange.to}
                min={customRange.from || undefined}
                onChange={(event) =>
                  setCustomRange((current) => ({
                    ...current,
                    to: event.target.value
                  }))
                }
              />
            </FilterField>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowCustomRange(false)}>
            {text.cancel}
          </Button>
          <Button variant="primary" disabled={!validCustomRange} onClick={applyCustomRange}>
            {text.apply}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RegistrationReviewFilters;
